import { useParams } from 'react-router-dom';
import { useUnmount } from 'ahooks';

import { Container, TitledContainer } from 'components';

import { getIsNew } from 'utils';

import {
  CopyOffer,
  OfferCollapses,
  OfferTabs,
  Title,
  TitleExtraNode,
} from './components';
import { resetOfferAction } from './store';

export const Offer = () => {
  const { offerId } = useParams();

  const isNew = getIsNew(offerId);

  useUnmount(() => {
    resetOfferAction();
  });

  return (
    <TitledContainer
      backLink
      scrollable
      title={<Title />}
      titleExtraNode={<TitleExtraNode />}
      underTitleNode={<CopyOffer />}
    >

      <Container className='mb-7'>
        <OfferCollapses />
      </Container>

      {!isNew && (
        <Container>
          <OfferTabs />
        </Container>
      )}

    </TitledContainer>
  );
};
